import { Conteiner, Titulo } from './styles';

export function CartaoDeInformacao({ titulo, texto, tipo }) {
  return (
    <Conteiner preenchimento={tipo}>
      {titulo && <Titulo>{titulo}</Titulo>}
      <p>{texto}</p>
    </Conteiner>
  );
}
